export default class ProofType {
  static None = '950773f0-7b3d-11e0-819a-0800200c9a66';
}
